import dynamic from 'next/dynamic';
import { RedemptionPanelProps } from './RedemptionPanel.types';

export const RedemptionPanelMGP = dynamic<RedemptionPanelProps>(() =>
  import('./RedemptionPanel').then(module => module)
);
